import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useAuthStore} from "@domains/auth/stores/auth.store";
import {AuthenticationNs} from "@shared/types";

export const logoutResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const authStore = useAuthStore();
    authStore.logout();
    next({name: AuthenticationNs.AuthenticationRouteEnums.SignIn});
};
